
import Vue from "vue";
import Component from "vue-class-component";
import { State, Action } from "vuex-class";

import MainTypeForm from "@/views/apps/registrationtypeform/MainTypeForm.vue";
import SchoolType from "@/views/apps/registrationtypeform/SchoolType.vue";
import CheckSchoolName from "@/views/apps/registrationtypeform/CheckSchoolName.vue";
import Domain from "@/views/apps/registrationtypeform/Domain.vue";
import PersonalInfo from "@/views/apps/registrationtypeform/PersonalInfo.vue";
import SchoolInfo from "@/views/apps/registrationtypeform/SchoolInfo.vue";
import ModalConfirmTypeForm from "@/components/typeform/ModalConfirmTypeForm.vue";
import ModalThankYou from "@/components/typeform/ModalThankYou.vue";
import { RegionState } from "@/store/region/types";
import { SchoolTypeModel } from "@/models/academy.model";
import { DomainChekcer, School } from "@/models/academy.types";

@Component({
  components: {
    MainTypeForm,
    SchoolType,
    CheckSchoolName,
    Domain,
    PersonalInfo,
    SchoolInfo,
    ModalConfirmTypeForm,
    ModalThankYou,
  },
})
export default class RegistrationTypeForm extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("authLayout") private authLayout: any;
  @Action("actionSelectSchoolTypeList", { namespace: "academy" })
  private actionSelectSchoolTypeList: any;
  @Action("actionSelectCountry", { namespace: "region" })
  private actionSelectCountry: any;
  @Action("actionLoadSchool", { namespace: "misc" })
  private actionLoadSchool: any;
  // ACTION TYPE FORM
  @Action("actionAddSchoolType", { namespace: "academy" })
  private actionAddSchoolType: any;
  @Action("actionAddSchoolNameTypeForm", { namespace: "academy" })
  private actionAddSchoolNameTypeForm: any;
  @Action("actionAddDomainTypeForm", { namespace: "academy" })
  private actionAddDomainTypeForm: any;
  @Action("actionAddPersonalInfo", { namespace: "academy" })
  private actionAddPersonalInfo: any;
  @Action("actionAddSchoolInfo", { namespace: "academy" })
  private actionAddSchoolInfo: any;
  @Action('actionCheckDomain', { namespace: 'academy' })
  private actionCheckDomain: any;
  
  // STATE
  @State("school", { namespace: 'academy'}) private school: School;
  @State('domain_checker', { namespace: 'academy'})
  private domain_checker: DomainChekcer;

  /* INITIALIZATION */
  private activeIndex: number = 0;
  private isShowConfirm: boolean = false;
  private isShowThanks: boolean = false;

  constructor() {
    super();
  }

  /* LIFECYCLE */
  // METHOD FIRST CALL ON COMPONENT ON LOAD
  private created() {
    this.authLayout();
    this.actionSelectSchoolTypeList();
    this.actionSelectCountry();
    // CHECK ON LOCAL STORAGE
    // SET ACTIVE INDEX PAGE ON ACTIVE INDEX AXIX IN LOCAL STORAGE
    const active_page = localStorage.getItem("active_page");
    if (active_page != null) {
      this.activeIndex = parseInt(active_page);
    }
    // GET LIST SCHOOL ON SCHOOL TYPE EXIST ON LOCAL STORAGE
    const school_type_string = localStorage.getItem("school_type");
    if (school_type_string != null) {
      const school_type = JSON.parse(school_type_string) as SchoolTypeModel;
      this.getListSchool(school_type);
    }
  }

  // METHODE
  // FUNCTION FOR HANDLE ON CLICK NEXT
  // SET ACTIVE INDEX TO LOCAL STORAGE
  private clickNext() {
    if (this.activeIndex < 5) {
      switch (this.activeIndex) {
        case 1:
          this.onNextSchoolType();
          break;
        case 2:
          this.onNextSchoolName();
          break;
        case 3:
          this.onNextDomain();
          break;
        case 4:
          this.onNextPersonalInfo();
          break;
        default:
          this.activeIndex++;
          localStorage.setItem("active_page", this.activeIndex.toString());
          break;
      }
    } else {
      if (
        this.$store.state.academy.school.validateRegistrationSchoolContact()
      ) {
        this.isShowConfirm = true;
      }
    }
  }

  // FUNCTION FOR NEXT SCHOOL TYPE
  private onNextSchoolType() {
    const id = localStorage.getItem("id_type_form");
    this.actionAddSchoolType({
      params: {
        id: id,
      },
      success: (res: any) => {
        this.activeIndex++;
        localStorage.setItem("active_page", this.activeIndex.toString());
      },
    });
  }

  // FUNCTION FOR NEXT SCHOOL NAME
  private onNextSchoolName() {
    const id = localStorage.getItem("id_type_form");
    this.actionAddSchoolNameTypeForm({
      params: {
        id: id,
      },
      success: (res: any) => {
        this.activeIndex++;
        localStorage.setItem("active_page", this.activeIndex.toString());
      },
    });
  }

  // FUNCTION FOR NEXT DOMAIN
  private actionAddDomain() {
    const id = localStorage.getItem("id_type_form");
    this.actionAddDomainTypeForm({
      params: {
        id: id,
      },
      success: (res: any) => {
        this.activeIndex++;
        localStorage.setItem("active_page", this.activeIndex.toString());
      },
    });
  }

  private onNextDomain() {
    if (this.school.subdomain) {
      this.school.subdomain = this.school.subdomain.replace(/\W+/g, '');
      this.school.subdomain = (this.school.subdomain as string).toLowerCase();
      this.actionCheckDomain({success: () => {
        this.actionAddDomain()
      }});
    } else {
      this.domain_checker.is_valid = false;
    }
  }

  // FUNCTION FOR NEXT SCHOOL NAME
  private onNextPersonalInfo() {
    const id = localStorage.getItem("id_type_form");
    this.actionAddPersonalInfo({
      params: {
        id: id,
      },
      success: (res: any) => {
        this.activeIndex++;
        localStorage.setItem("active_page", this.activeIndex.toString());
      },
    });
  }

  // FUNCTION FOR NEXT COMPANY INFO
  private onNextSchoolInfo() {
    const id = localStorage.getItem("id_type_form");
    this.actionAddSchoolInfo({
      params: {
        id: id,
      },
      success: (res: any) => {
        this.isShowConfirm = false;
        this.isShowThanks = true;
      },
    });
  }

  // FUNCTION FOR HANDLE ON CLICK BACK
  private clickBack() {
    if (this.activeIndex == 1) {
      window.location.href = "https://www.career.support/id/edu/";
      localStorage.clear();
    } else {
      this.activeIndex--;
    }
    // localStorage.setItem("active_page", this.activeIndex.toString());
  }

  // FUNCTION FOR GET LIST SCHOOL
  private getListSchool(schoolType: SchoolTypeModel) {
    this.actionLoadSchool({
      params: {
        schooltype: schoolType.id,
      },
      success: (response: any) => {
        // TODO
      },
      fail: (response: any) => {
        // TODO
      },
    });
  }
}
